{
  "HELP_CENTER": {
    "TITLE": "도움말 센터",
    "NEW_PAGE": {
      "DESCRIPTION": "고객을 위한 셀프 서비스 도움말 센터 포털을 생성하십시오. 고객이 대기 없이 빠르게 답변을 찾을 수 있도록 도와줍니다. 문의를 간소화하고 에이전트 효율성을 높이며 고객 지원을 향상시킵니다.",
      "CREATE_PORTAL_BUTTON": "포털 만들기"
    },
    "HEADER": {
      "FILTER": "필터",
      "SORT": "정렬",
      "LOCALE": "로케일",
      "SETTINGS_BUTTON": "설정",
      "NEW_BUTTON": "새 게시물",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "게시됨",
        "DRAFT": "임시 저장",
        "ARCHIVED": "보관됨"
      },
      "TITLES": {
        "ALL_ARTICLES": "모든 게시물",
        "MINE": "내 게시물",
        "DRAFT": "임시 저장 게시물",
        "ARCHIVED": "보관된 게시물"
      },
      "LOCALE_SELECT": {
        "TITLE": "로케일 선택",
        "PLACEHOLDER": "로케일 선택",
        "NO_RESULT": "로케일을 찾을 수 없습니다",
        "SEARCH_PLACEHOLDER": "로케일 검색"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "모든 게시물",
      "PUBLISH_BUTTON": "게시",
      "MOVE_TO_ARCHIVE_BUTTON": "보관함으로 이동",
      "PREVIEW": "미리보기",
      "ADD_TRANSLATION": "번역 추가",
      "OPEN_SIDEBAR": "사이드바 열기",
      "CLOSE_SIDEBAR": "사이드바 닫기",
      "SAVING": "저장 중...",
      "SAVED": "저장됨"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "이미지 업로드",
        "UPLOADING": "업로드 중...",
        "SUCCESS": "이미지가 성공적으로 업로드되었습니다",
        "ERROR": "이미지 업로드 중 오류가 발생했습니다",
        "UN_AUTHORIZED_ERROR": "이미지를 업로드할 권한이 없습니다",
        "ERROR_FILE_SIZE": "이미지 크기는 {size}MB 미만이어야 합니다",
        "ERROR_FILE_FORMAT": "이미지 형식은 jpg, jpeg 또는 png여야 합니다",
        "ERROR_FILE_DIMENSIONS": "이미지 크기는 2000 x 2000 미만이어야 합니다"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "게시물 설정",
      "FORM": {
        "CATEGORY": {
          "LABEL": "카테고리",
          "TITLE": "카테고리 선택",
          "PLACEHOLDER": "카테고리 선택",
          "NO_RESULT": "카테고리를 찾을 수 없습니다",
          "SEARCH_PLACEHOLDER": "카테고리 검색"
        },
        "AUTHOR": {
          "LABEL": "작성자",
          "TITLE": "작성자 선택",
          "PLACEHOLDER": "작성자 선택",
          "NO_RESULT": "작성자를 찾을 수 없습니다",
          "SEARCH_PLACEHOLDER": "작성자 검색"
        },
        "META_TITLE": {
          "LABEL": "메타 제목",
          "PLACEHOLDER": "메타 제목을 추가하십시오"
        },
        "META_DESCRIPTION": {
          "LABEL": "메타 설명",
          "PLACEHOLDER": "더 나은 SEO 결과를 위해 메타 설명을 추가하십시오..."
        },
        "META_TAGS": {
          "LABEL": "메타 태그",
          "PLACEHOLDER": "쉼표로 구분하여 메타 태그를 추가하십시오..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "게시물 보관",
        "DELETE": "게시물 삭제"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "미분류",
      "SEARCH_RESULTS": "{query}에 대한 검색 결과",
      "EMPTY_TEXT": "답장에 삽입할 게시물을 검색하십시오.",
      "SEARCH_LOADER": "검색중...",
      "INSERT_ARTICLE": "삽입",
      "NO_RESULT": "게시물을 찾을 수 없습니다",
      "COPY_LINK": "게시물 링크를 클립보드에 복사",
      "OPEN_LINK": "새 탭에서 게시물 열기",
      "PREVIEW_LINK": "게시물 미리보기"
    },
    "PORTAL": {
      "HEADER": "포털",
      "DEFAULT": "기본값",
      "NEW_BUTTON": "새 포털",
      "ACTIVE_BADGE": "활성",
      "CHOOSE_LOCALE_LABEL": "로케일 선택",
      "LOADING_MESSAGE": "포털을 불러오는 중...",
      "ARTICLES_LABEL": "게시물",
      "NO_PORTALS_MESSAGE": "사용 가능한 포털이 없습니다",
      "ADD_NEW_LOCALE": "새 로케일 추가",
      "POPOVER": {
        "TITLE": "포털",
        "PORTAL_SETTINGS": "포털 설정",
        "SUBTITLE": "여러 포털이 있으며 각 포털에 대해 다른 로케일을 사용할 수 있습니다.",
        "CANCEL_BUTTON_LABEL": "취소",
        "CHOOSE_LOCALE_BUTTON": "로케일 선택"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "게시물",
            "ADD": "로케일 추가",
            "VISIT": "사이트 방문",
            "SETTINGS": "설정",
            "DELETE": "삭제"
          },
          "PORTAL_CONFIG": {
            "TITLE": "포털 설정",
            "ITEMS": {
              "NAME": "이름",
              "DOMAIN": "사용자 지정 도메인",
              "SLUG": "슬러그",
              "TITLE": "포털 제목",
              "THEME": "테마 색상",
              "SUB_TEXT": "포털 부제"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "사용 가능한 로케일",
            "TABLE": {
              "NAME": "로케일 이름",
              "CODE": "로케일 코드",
              "ARTICLE_COUNT": "게시물 수",
              "CATEGORIES": "카테고리 수",
              "SWAP": "교환",
              "DELETE": "삭제",
              "DEFAULT_LOCALE": "기본값"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "포털 삭제",
          "MESSAGE": "이 포털을 삭제하시겠습니까?",
          "YES": "예, 포털을 삭제합니다",
          "NO": "아니요, 포털을 유지합니다",
          "API": {
            "DELETE_SUCCESS": "포털이 성공적으로 삭제되었습니다",
            "DELETE_ERROR": "포털 삭제 중 오류가 발생했습니다"
          }
        },
        "SEND_CNAME_INSTRUCTIONS": {
          "API": {
            "SUCCESS_MESSAGE": "CNAME 안내가 성공적으로 전송되었습니다",
            "ERROR_MESSAGE": "CNAME 안내 전송 중 오류가 발생했습니다"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "포털 수정",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "기본 정보"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "포털 사용자 지정"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "카테고리"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "로케일"
          }
        },
        "CATEGORIES": {
          "TITLE": "카테고리",
          "NEW_CATEGORY": "새 카테고리",
          "TABLE": {
            "NAME": "이름",
            "DESCRIPTION": "설명",
            "LOCALE": "로케일",
            "ARTICLE_COUNT": "게시물 수",
            "ACTION_BUTTON": {
              "EDIT": "카테고리 수정",
              "DELETE": "카테고리 삭제"
            },
            "EMPTY_TEXT": "카테고리를 찾을 수 없습니다"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "기본 설정 업데이트"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "도움말 센터 정보",
            "BODY": "포털에 대한 기본 정보"
          },
          "CUSTOMIZATION": {
            "TITLE": "도움말 센터 사용자 지정",
            "BODY": "포털 사용자 지정"
          },
          "FINISH": {
            "TITLE": "Voila! 🎉",
            "BODY": "모든 설정이 완료되었습니다!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "뒤로",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "포털 만들기",
            "TITLE": "도움말 센터 정보",
            "CREATE_BASIC_SETTING_BUTTON": "포털 기본 설정 만들기"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "포털 사용자 지정",
            "TITLE": "도움말 센터 사용자 지정",
            "UPDATE_PORTAL_BUTTON": "포털 설정 업데이트"
          },
          "FINISH_PAGE": {
            "TITLE": "Voila!🎉 모든 설정이 완료되었습니다!",
            "MESSAGE": "이제 모든 포털 페이지에서 생성된 포털을 확인할 수 있습니다.",
            "FINISH": "모든 포털 페이지로 이동"
          }
        },
        "LOGO": {
          "LABEL": "로고",
          "UPLOAD_BUTTON": "로고 업로드",
          "HELP_TEXT": "이 로고는 포털 헤더에 표시됩니다.",
          "IMAGE_UPLOAD_SUCCESS": "로고가 성공적으로 업로드되었습니다",
          "IMAGE_UPLOAD_ERROR": "로고가 성공적으로 삭제되었습니다",
          "IMAGE_DELETE_ERROR": "로고 삭제 중 오류가 발생했습니다"
        },
        "NAME": {
          "LABEL": "이름",
          "PLACEHOLDER": "포털 이름",
          "HELP_TEXT": "이 이름은 내부적으로 공개 포털에 사용됩니다.",
          "ERROR": "이름이 필요합니다"
        },
        "SLUG": {
          "LABEL": "슬러그",
          "PLACEHOLDER": "URL용 포털 슬러그",
          "ERROR": "슬러그가 필요합니다"
        },
        "DOMAIN": {
          "LABEL": "사용자 지정 도메인",
          "PLACEHOLDER": "포털 사용자 지정 도메인",
          "HELP_TEXT": "포털에 사용자 지정 도메인을 사용하려는 경우에만 추가하십시오. 예: {exampleURL}",
          "ERROR": "유효한 도메인 URL을 입력하십시오"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "홈페이지 링크",
          "PLACEHOLDER": "포털 홈페이지 링크",
          "HELP_TEXT": "포털에서 홈페이지로 돌아가는 데 사용되는 링크입니다. 예: {exampleURL}",
          "ERROR": "유효한 홈페이지 URL을 입력하십시오"
        },
        "THEME_COLOR": {
          "LABEL": "포털 테마 색상",
          "HELP_TEXT": "이 색상이 포털의 테마 색상으로 표시됩니다."
        },
        "PAGE_TITLE": {
          "LABEL": "페이지 제목",
          "PLACEHOLDER": "포털 페이지 제목",
          "HELP_TEXT": "페이지 제목은 공개 포털에서 사용됩니다.",
          "ERROR": "페이지 제목이 필요합니다"
        },
        "HEADER_TEXT": {
          "LABEL": "헤더 텍스트",
          "PLACEHOLDER": "포털 헤더 텍스트",
          "HELP_TEXT": "포털 헤더 텍스트는 공개 포털에서 사용됩니다.",
          "ERROR": "포털 헤더 텍스트가 필요합니다"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "포털이 성공적으로 생성되었습니다.",
          "ERROR_MESSAGE_FOR_BASIC": "포털을 만들 수 없습니다. 다시 시도하십시오.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "포털이 성공적으로 업데이트되었습니다.",
          "ERROR_MESSAGE_FOR_UPDATE": "포털을 업데이트할 수 없습니다. 다시 시도하십시오."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "새 로케일 추가",
        "SUB_TITLE": "사용 가능한 번역 목록에 새 로케일을 추가합니다.",
        "PORTAL": "포털",
        "LOCALE": {
          "LABEL": "로케일",
          "PLACEHOLDER": "로케일을 선택하십시오",
          "ERROR": "로케일이 필요합니다"
        },
        "BUTTONS": {
          "CREATE": "로케일 만들기",
          "CANCEL": "취소"
        },
        "API": {
          "SUCCESS_MESSAGE": "로케일이 성공적으로 추가되었습니다",
          "ERROR_MESSAGE": "로케일을 추가할 수 없습니다. 다시 시도하십시오."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "기본 로케일이 성공적으로 업데이트되었습니다",
          "ERROR_MESSAGE": "기본 로케일을 업데이트할 수 없습니다. 다시 시도하십시오."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "포털에서 로케일이 성공적으로 제거되었습니다",
          "ERROR_MESSAGE": "포털에서 로케일을 제거할 수 없습니다. 다시 시도하십시오."
        }
      },
      "DRAFT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale moved to draft successfully",
          "ERROR_MESSAGE": "Unable to move locale to draft. Try again."
        }
      },
      "PUBLISH_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale published successfully",
          "ERROR_MESSAGE": "Unable to publish locale. Try again."
        }
      }
    },
    "TABLE": {
      "LOADING_MESSAGE": "게시물을 불러오는 중...",
      "404": "검색과 일치하는 게시물이 없습니다 🔍",
      "NO_ARTICLES": "사용 가능한 게시물이 없습니다",
      "HEADERS": {
        "TITLE": "제목",
        "CATEGORY": "카테고리",
        "READ_COUNT": "조회수",
        "STATUS": "상태",
        "LAST_EDITED": "마지막 수정"
      },
      "COLUMNS": {
        "BY": "작성자",
        "AUTHOR_NOT_AVAILABLE": "작성자를 사용할 수 없습니다"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "게시물을 불러오는 중...",
      "TITLE_PLACEHOLDER": "게시물 제목을 입력하십시오",
      "CONTENT_PLACEHOLDER": "게시물을 작성하십시오",
      "API": {
        "ERROR": "게시물 저장 중 오류가 발생했습니다"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "게시물 게시 중 오류가 발생했습니다",
        "SUCCESS": "게시물이 성공적으로 게시되었습니다"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "게시물 보관 중 오류가 발생했습니다",
        "SUCCESS": "게시물이 성공적으로 보관되었습니다"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "게시물 임시 저장 중 오류가 발생했습니다",
        "SUCCESS": "게시물이 성공적으로 임시 저장되었습니다"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "삭제 확인",
          "MESSAGE": "게시물을 삭제하시겠습니까?",
          "YES": "예, 삭제합니다",
          "NO": "아니요, 유지합니다."
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "게시물이 성공적으로 삭제되었습니다",
        "ERROR_MESSAGE": "게시물 삭제 중 오류가 발생했습니다"
      }
    },
    "REORDER_ARTICLE": {
      "API": {
        "ERROR_MESSAGE": "문서 순서를 변경할 수 없습니다. 다시 시도하십시오."
      }
    },
    "REORDER_CATEGORY": {
      "API": {
        "ERROR_MESSAGE": "카테고리 순서를 변경할 수 없습니다. 다시 시도하십시오."
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "게시물 제목과 내용을 추가해야 설정을 업데이트할 수 있습니다"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "게시물 검색"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "카테고리 만들기",
        "SUB_TITLE": "카테고리는 공개 포털에서 게시물을 분류하는 데 사용됩니다.",
        "PORTAL": "포털",
        "LOCALE": "로케일",
        "NAME": {
          "LABEL": "이름",
          "PLACEHOLDER": "카테고리 이름",
          "HELP_TEXT": "카테고리 이름과 아이콘은 공개 포털에서 게시물을 분류하는 데 사용됩니다.",
          "ERROR": "이름이 필요합니다"
        },
        "SLUG": {
          "LABEL": "슬러그",
          "PLACEHOLDER": "URL용 카테고리 슬러그",
          "HELP_TEXT": "app.chatwoot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "슬러그가 필요합니다"
        },
        "DESCRIPTION": {
          "LABEL": "설명",
          "PLACEHOLDER": "카테고리에 대한 간단한 설명을 입력하십시오.",
          "ERROR": "설명이 필요합니다"
        },
        "BUTTONS": {
          "CREATE": "카테고리 만들기",
          "CANCEL": "취소"
        },
        "API": {
          "SUCCESS_MESSAGE": "카테고리가 성공적으로 생성되었습니다",
          "ERROR_MESSAGE": "카테고리를 생성할 수 없습니다"
        }
      },
      "EDIT": {
        "TITLE": "카테고리 수정",
        "SUB_TITLE": "카테고리를 수정하면 공개 포털의 카테고리가 업데이트됩니다.",
        "PORTAL": "포털",
        "LOCALE": "로케일",
        "NAME": {
          "LABEL": "이름",
          "PLACEHOLDER": "카테고리 이름",
          "HELP_TEXT": "카테고리 이름과 아이콘은 공개 포털에서 게시물을 분류하는 데 사용됩니다.",
          "ERROR": "이름이 필요합니다"
        },
        "SLUG": {
          "LABEL": "슬러그",
          "PLACEHOLDER": "URL용 카테고리 슬러그",
          "HELP_TEXT": "app.chatwoot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "슬러그가 필요합니다"
        },
        "DESCRIPTION": {
          "LABEL": "설명",
          "PLACEHOLDER": "카테고리에 대한 간단한 설명을 입력하십시오.",
          "ERROR": "설명이 필요합니다"
        },
        "BUTTONS": {
          "CREATE": "카테고리 업데이트",
          "CANCEL": "취소"
        },
        "API": {
          "SUCCESS_MESSAGE": "카테고리가 성공적으로 업데이트되었습니다",
          "ERROR_MESSAGE": "카테고리를 업데이트할 수 없습니다"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "카테고리가 성공적으로 삭제되었습니다",
          "ERROR_MESSAGE": "카테고리를 삭제할 수 없습니다"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "게시물 검색",
      "PLACEHOLDER": "게시물 검색",
      "NO_RESULT": "게시물을 찾을 수 없습니다",
      "SEARCHING": "검색중...",
      "SEARCH_BUTTON": "검색",
      "INSERT_ARTICLE": "링크 삽입",
      "IFRAME_ERROR": "URL이 비어 있거나 유효하지 않습니다. 콘텐츠를 표시할 수 없습니다.",
      "OPEN_ARTICLE_SEARCH": "도움말 센터에서 게시물 삽입",
      "SUCCESS_ARTICLE_INSERTED": "게시물이 성공적으로 삽입되었습니다",
      "PREVIEW_LINK": "게시물 미리보기",
      "CANCEL": "닫기",
      "BACK": "뒤로",
      "BACK_RESULTS": "결과로 돌아가기"
    },
    "UPGRADE_PAGE": {
      "TITLE": "도움말 센터",
      "DESCRIPTION": "사용자 친화적인 셀프 서비스 포털을 만드십시오. 사용자가 게시물에 접근하고 연중무휴 지원을 받을 수 있도록 도와줍니다. 이 기능을 활성화하려면 구독을 업그레이드하십시오.",
      "SELF_HOSTED_DESCRIPTION": "사용자 친화적인 셀프 서비스 포털을 만드십시오. 사용자가 게시물에 접근하고 연중무휴 지원을 받을 수 있도록 도와줍니다. 이 기능을 활성화하려면 관리자에게 문의하십시오.",
      "BUTTON": {
        "LEARN_MORE": "자세히 알아보기",
        "UPGRADE": "업그레이드"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "다중 포털",
          "DESCRIPTION": "동일한 계정을 사용하여 다양한 제품에 대한 여러 도움말 센터 포털을 만들 수 있습니다."
        },
        "LOCALES": {
          "TITLE": "로케일 전체 지원",
          "DESCRIPTION": "포털을 원하는 언어로 현지화할 수 있습니다. 모든 로케일을 지원하며 모든 게시물에 대해 번역을 허용합니다."
        },
        "SEO": {
          "TITLE": "SEO 친화적 디자인",
          "DESCRIPTION": "SEO 친화적 페이지를 통해 메타 태그를 사용자 지정하여 검색 엔진에서의 가시성을 높이십시오."
        },
        "API": {
          "TITLE": "전체 API 지원",
          "DESCRIPTION": "API를 사용하여 타사 프론트엔드 프레임워크와 함께 포털을 헤드리스 CMS로 사용하십시오."
        }
      }
    },
    "LOADING": "불러오는 중...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count}회 조회 | {count}회 조회",
          "DROPDOWN_MENU": {
            "PUBLISH": "게시",
            "DRAFT": "임시 저장",
            "ARCHIVE": "보관",
            "TRANSLATE": "번역",
            "DELETE": "삭제"
          },
          "STATUS": {
            "DRAFT": "임시 저장",
            "PUBLISHED": "게시됨",
            "ARCHIVED": "보관됨"
          },
          "PENDING_EDITS": "Unpublished edits",
          "PENDING_EDITS_TOOLTIP": "This published article has unpublished edits",
          "CATEGORY": {
            "UNCATEGORISED": "미분류"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "모든 게시물",
          "MINE": "나에게 할당",
          "DRAFT": "임시 저장",
          "PUBLISHED": "게시됨",
          "ARCHIVED": "보관됨"
        },
        "CATEGORY": {
          "ALL": "모든 카테고리"
        },
        "LOCALE": {
          "ALL": "모든 로케일"
        },
        "SEARCH_PLACEHOLDER": "게시물 검색...",
        "NEW_ARTICLE": "새 게시물"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "게시물 작성",
          "SUBTITLE": "풍부한 게시물을 작성해 보세요!",
          "BUTTON_LABEL": "새 게시물"
        },
        "MINE": {
          "TITLE": "아직 작성한 게시물이 없습니다",
          "SUBTITLE": "작성한 모든 게시물이 여기에 빠른 액세스를 위해 표시됩니다."
        },
        "DRAFT": {
          "TITLE": "임시 저장된 게시물이 없습니다",
          "SUBTITLE": "임시 저장된 게시물이 여기에 표시됩니다"
        },
        "PUBLISHED": {
          "TITLE": "게시된 게시물이 없습니다",
          "SUBTITLE": "게시된 게시물이 여기에 표시됩니다"
        },
        "ARCHIVED": {
          "TITLE": "보관된 게시물이 없습니다",
          "SUBTITLE": "보관된 게시물은 포털에 표시되지 않으며, 더 이상 사용되지 않거나 오래된 페이지를 표시하는 데 사용할 수 있습니다"
        },
        "CATEGORY": {
          "TITLE": "이 카테고리에 게시물이 없습니다",
          "SUBTITLE": "이 카테고리의 게시물이 여기에 표시됩니다"
        },
        "SEARCH": {
          "TITLE": "No matching articles",
          "SUBTITLE": "We couldn't find any articles matching your search. Try a different term."
        }
      },
      "BULK_TRANSLATE": {
        "TITLE": "Translate article | Translate {count} articles",
        "DESCRIPTION": "Translate the selected article to another language. | Translate the selected articles to another language.",
        "LOCALE_LABEL": "Target language",
        "LOCALE_PLACEHOLDER": "Select a language",
        "CATEGORY_LABEL": "Target category",
        "CATEGORY_PLACEHOLDER": "Select a category",
        "OPTIONAL": "(optional)",
        "CONFIRM": "번역",
        "SELECT_ALL": "전체 선택 ({count})",
        "SELECTED_COUNT": "{count}개 선택됨",
        "CLEAR_SELECTION": "선택 해제",
        "TRANSLATE_BUTTON": "번역",
        "CONFIRM_OVERWRITE": "Overwrite and translate",
        "DUPLICATE_WARNING": "A translation already exists for this article in the selected language. | Translations already exist for {count} articles in the selected language.",
        "DUPLICATE_CONFIRM_HINT": "Click translate again to overwrite the existing translation.",
        "API": {
          "SUCCESS_MESSAGE": "Translation in progress. The article will appear as a draft once ready.",
          "ERROR_MESSAGE": "Failed to start translation. Please try again."
        }
      },
      "BULK_ACTIONS": {
        "PUBLISH": "게시",
        "DRAFT": "임시 저장",
        "ARCHIVE": "보관",
        "TRANSLATE": "번역",
        "MOVE_TO_CATEGORY": "카테고리",
        "DELETE": "삭제",
        "STATUS_SUCCESS": "Articles updated successfully",
        "STATUS_ERROR": "Failed to update articles",
        "STATUS_SKIPPED": "1 article with unpublished edits was skipped — open it to publish or discard. | {count} articles with unpublished edits were skipped — open them to publish or discard.",
        "STATUS_SKIPPED_ALL": "These articles have unpublished edits — open each to publish or discard.",
        "CATEGORY_SUCCESS": "Articles moved successfully",
        "CATEGORY_ERROR": "Failed to move articles",
        "DELETE_CONFIRM_TITLE": "Delete article | Delete {count} articles",
        "DELETE_CONFIRM_DESCRIPTION": "This will permanently delete the selected article. This action cannot be undone. | This will permanently delete {count} selected articles. This action cannot be undone.",
        "DELETE_CONFIRM": "삭제",
        "DELETE_SUCCESS": "Articles deleted successfully",
        "DELETE_ERROR": "Failed to delete articles"
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "새 카테고리",
        "EDIT_CATEGORY": "카테고리 수정",
        "SEARCH_PLACEHOLDER": "Search categories...",
        "CATEGORIES_COUNT": "{n}개 카테고리 | {n}개 카테고리",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "카테고리 ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount}개 게시물) | {categoryName} ({categoryCount}개 게시물)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "카테고리를 찾을 수 없습니다",
        "SUBTITLE": "카테고리가 여기에 표시됩니다. '새 카테고리' 버튼을 클릭하여 카테고리를 추가할 수 있습니다."
      },
      "SEARCH_EMPTY_STATE": {
        "TITLE": "No matching categories",
        "SUBTITLE": "We couldn't find any categories matching your search. Try a different term."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count}개 게시물 | {count}개 게시물"
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "카테고리가 성공적으로 생성되었습니다",
            "ERROR_MESSAGE": "카테고리를 생성할 수 없습니다"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "카테고리가 성공적으로 업데이트되었습니다",
            "ERROR_MESSAGE": "카테고리를 업데이트할 수 없습니다"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "카테고리가 성공적으로 삭제되었습니다",
            "ERROR_MESSAGE": "카테고리를 삭제할 수 없습니다"
          }
        },
        "HEADER": {
          "CREATE": "카테고리 만들기",
          "EDIT": "카테고리 수정",
          "DESCRIPTION": "카테고리를 수정하면 공개 포털의 카테고리가 업데이트됩니다.",
          "PORTAL": "포털",
          "LOCALE": "로케일"
        },
        "FORM": {
          "NAME": {
            "LABEL": "이름",
            "PLACEHOLDER": "카테고리 이름",
            "ERROR": "이름이 필요합니다"
          },
          "SLUG": {
            "LABEL": "슬러그",
            "PLACEHOLDER": "URL용 카테고리 슬러그",
            "ERROR": "슬러그가 필요합니다",
            "HELP_TEXT": "app.chatwoot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "설명",
            "PLACEHOLDER": "카테고리에 대한 간단한 설명을 입력하십시오.",
            "ERROR": "설명이 필요합니다"
          }
        },
        "BUTTONS": {
          "CREATE": "만들기",
          "EDIT": "업데이트",
          "CANCEL": "취소"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "사용 가능한 로케일 없음 | {n}개 로케일 | {n}개 로케일",
      "NEW_LOCALE_BUTTON_TEXT": "새 로케일",
      "SEARCH_PLACEHOLDER": "Search locales...",
      "SEARCH_EMPTY_STATE": {
        "TITLE": "No matching locales",
        "SUBTITLE": "We couldn't find any locales matching your search. Try a different term."
      },
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count}개 게시물 | {count}개 게시물",
        "CATEGORIES_COUNT": "{count}개 카테고리 | {count}개 카테고리",
        "DEFAULT": "기본값",
        "DRAFT": "임시 저장",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "기본값으로 설정",
          "MOVE_TO_DRAFT": "Move to draft",
          "PUBLISH_LOCALE": "Publish locale",
          "CUSTOMIZE_CONTENT": "Localize content",
          "SELECT_POPULAR_CONTENT": "Select recommended content",
          "DELETE": "삭제"
        }
      },
      "POPULAR_CONTENT_DIALOG": {
        "TITLE": "Recommended content",
        "DESCRIPTION": "Pick up to 3 categories and 6 articles to feature on this locale's help center home page. Drag them into the order you want visitors to see.",
        "SEARCH": "검색...",
        "EMPTY": "No matching results",
        "ADD_ANOTHER": "Add another...",
        "SLOTS_LEFT": "{count} slots left",
        "OVERRIDING_DEFAULTS": "Overriding defaults for this locale",
        "CONFIRM": "Save recommendations",
        "CATEGORIES": {
          "LABEL": "Recommended categories",
          "ARTICLES_COUNT": "No articles | {count} article | {count} articles"
        },
        "ARTICLES": {
          "LABEL": "Recommended articles",
          "IN_CATEGORY": "in {category}",
          "UNCATEGORIZED": "미분류"
        },
        "API": {
          "SUCCESS_MESSAGE": "Recommended content updated successfully",
          "ERROR_MESSAGE": "Unable to update recommended content. Try again."
        }
      },
      "CONTENT_DIALOG": {
        "TITLE": "Localize content",
        "DESCRIPTION": "Set values specific to this locale. Anything left blank falls back to the default locale.",
        "NAME": {
          "LABEL": "이름"
        },
        "PAGE_TITLE": {
          "LABEL": "페이지 제목"
        },
        "HEADER_TEXT": {
          "LABEL": "헤더 텍스트"
        },
        "API": {
          "SUCCESS_MESSAGE": "Locale content updated successfully",
          "ERROR_MESSAGE": "Unable to update locale content. Try again."
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "새 로케일 추가",
        "DESCRIPTION": "이 게시물이 작성될 언어를 선택하십시오. 번역 목록에 추가되며 나중에 더 추가할 수 있습니다.",
        "COMBOBOX": {
          "PLACEHOLDER": "로케일 선택..."
        },
        "STATUS": {
          "LABEL": "상태",
          "OPTIONS": {
            "LIVE": "게시됨",
            "DRAFT": "임시 저장"
          }
        },
        "API": {
          "SUCCESS_MESSAGE": "로케일이 성공적으로 추가되었습니다",
          "ERROR_MESSAGE": "로케일을 추가할 수 없습니다. 다시 시도하십시오."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "저장 중...",
          "SAVED": "저장됨"
        },
        "PREVIEW": "미리보기",
        "PUBLISH": "게시",
        "PUBLISH_CHANGES": "Publish changes",
        "PUBLISH_CHANGES_SUCCESS": "Changes published successfully",
        "PUBLISH_CHANGES_ERROR": "Could not publish changes",
        "SAVE_IN_PROGRESS": "Still saving your latest changes — please try again in a moment.",
        "DISCARD_CHANGES": "Discard changes",
        "DISCARD_CHANGES_SUCCESS": "Changes discarded",
        "DISCARD_CHANGES_ERROR": "Could not discard changes",
        "PENDING_CHANGES": "Pending changes",
        "VIEW_CHANGES": "View unpublished changes",
        "DRAFT": "임시 저장",
        "ARCHIVE": "보관",
        "BACK_TO_ARTICLES": "게시물로 돌아가기"
      },
      "PENDING_CHANGES_POPOVER": {
        "TITLE": "Unpublished changes",
        "DESCRIPTION": "This article has draft changes that aren't live yet. Apply them before changing the status, or discard them?",
        "APPLY": "Apply changes",
        "DISCARD": "Discard changes"
      },
      "DIFF_DIALOG": {
        "TITLE": "Unpublished changes",
        "DESCRIPTION": "Compare your draft against the version that's currently live.",
        "TITLE_LABEL": "제목"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "추가 속성",
        "UNCATEGORIZED": "카테고리가 지정되지 않음",
        "EDITOR_PLACEHOLDER": "내용을 작성하십시오..."
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "게시물 속성",
        "META_DESCRIPTION": "메타 설명",
        "META_DESCRIPTION_PLACEHOLDER": "메타 설명 추가",
        "META_TITLE": "메타 제목",
        "META_TITLE_PLACEHOLDER": "메타 제목 추가",
        "META_TAGS": "메타 태그",
        "META_TAGS_PLACEHOLDER": "메타 태그 추가"
      },
      "API": {
        "ERROR": "게시물 저장 중 오류가 발생했습니다"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "새 포털",
      "PORTALS": "포털",
      "CREATE_PORTAL": "여러 포털을 만들고 관리하십시오",
      "ARTICLES": "게시물",
      "DOMAIN": "도메인",
      "PORTAL_NAME": "포털 이름"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "새 포털 만들기",
      "DESCRIPTION": "포털에 이름을 지정하고 사용자 친화적인 URL 슬러그를 만드십시오. 나중에 설정에서 둘 다 수정할 수 있습니다.",
      "CONFIRM_BUTTON_LABEL": "만들기",
      "NAME": {
        "LABEL": "이름",
        "PLACEHOLDER": "사용자 가이드 | Chatwoot",
        "MESSAGE": "포털의 이름을 선택하십시오.",
        "ERROR": "이름이 필요합니다"
      },
      "SLUG": {
        "LABEL": "슬러그",
        "PLACEHOLDER": "user-guide",
        "ERROR": "슬러그가 필요합니다",
        "FORMAT_ERROR": "유효한 슬러그를 입력하십시오. 예: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "로고",
          "IMAGE_UPLOAD_ERROR": "이미지를 업로드할 수 없습니다! 다시 시도하십시오",
          "IMAGE_UPLOAD_SUCCESS": "이미지가 성공적으로 추가되었습니다. 로고를 저장하려면 변경사항 저장을 클릭하십시오",
          "IMAGE_DELETE_SUCCESS": "로고가 성공적으로 삭제되었습니다",
          "IMAGE_DELETE_ERROR": "로고를 삭제할 수 없습니다",
          "IMAGE_UPLOAD_SIZE_ERROR": "이미지 크기는 {size}MB 미만이어야 합니다"
        },
        "NAME": {
          "LABEL": "이름",
          "PLACEHOLDER": "포털 이름",
          "ERROR": "이름이 필요합니다"
        },
        "HEADER_TEXT": {
          "LABEL": "헤더 텍스트",
          "PLACEHOLDER": "포털 헤더 텍스트"
        },
        "PAGE_TITLE": {
          "LABEL": "페이지 제목",
          "PLACEHOLDER": "포털 페이지 제목"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "홈페이지 링크",
          "PLACEHOLDER": "포털 홈페이지 링크",
          "ERROR": "유효한 URL을 입력하십시오. 홈페이지 링크는 'http://' 또는 'https://'로 시작해야 합니다."
        },
        "SLUG": {
          "LABEL": "슬러그",
          "PLACEHOLDER": "포털 슬러그"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "실시간 채팅 위젯",
          "PLACEHOLDER": "실시간 채팅 위젯 선택",
          "HELP_TEXT": "도움말 센터에 표시될 실시간 채팅 위젯을 선택하십시오",
          "NONE_OPTION": "위젯 없음"
        },
        "BRAND_COLOR": {
          "LABEL": "브랜드 색상"
        },
        "SAVE_CHANGES": "변경사항 저장"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "사용자 지정 도메인",
          "LABEL": "사용자 지정 도메인:",
          "DESCRIPTION": "포털을 사용자 지정 도메인에서 호스팅할 수 있습니다. 예를 들어, 웹사이트가 yourdomain.com이고 포털을 docs.yourdomain.com에서 사용하려면 이 필드에 입력하십시오.",
          "STATUS_DESCRIPTION": "사용자 지정 포털은 확인되는 즉시 작동합니다.",
          "PLACEHOLDER": "포털 사용자 지정 도메인",
          "EDIT_BUTTON": "수정",
          "ADD_BUTTON": "사용자 지정 도메인 추가",
          "STATUS": {
            "LIVE": "활성",
            "PENDING": "확인 대기 중",
            "ERROR": "확인 실패"
          },
          "DIALOG": {
            "ADD_HEADER": "사용자 지정 도메인 추가",
            "EDIT_HEADER": "사용자 지정 도메인 수정",
            "ADD_CONFIRM_BUTTON_LABEL": "도메인 추가",
            "EDIT_CONFIRM_BUTTON_LABEL": "도메인 업데이트",
            "LABEL": "사용자 지정 도메인",
            "PLACEHOLDER": "포털 사용자 지정 도메인",
            "ERROR": "사용자 지정 도메인이 필요합니다",
            "FORMAT_ERROR": "유효한 도메인 URL을 입력하십시오. 예: docs.yourdomain.com"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS 설정",
            "DESCRIPTION": "DNS 공급자 계정에 로그인하여 서브도메인에 대한 CNAME 레코드를 chatwoot.help로 가리키도록 추가하십시오",
            "COPY": "CNAME이 성공적으로 복사되었습니다",
            "SEND_INSTRUCTIONS": {
              "HEADER": "안내 전송",
              "DESCRIPTION": "개발 팀의 담당자가 이 단계를 처리하도록 하려면 아래에 이메일 주소를 입력하시면 필요한 안내를 보내드립니다.",
              "PLACEHOLDER": "이메일을 입력하십시오",
              "ERROR": "유효한 이메일 주소를 입력하십시오",
              "SEND_BUTTON": "보내기"
            }
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "{portalName} 삭제",
          "HEADER": "포털 삭제",
          "DESCRIPTION": "이 포털을 영구적으로 삭제합니다. 이 작업은 되돌릴 수 없습니다",
          "DIALOG": {
            "HEADER": "{portalName}을(를) 삭제하시겠습니까?",
            "DESCRIPTION": "이 작업은 되돌릴 수 없는 영구적인 작업입니다.",
            "CONFIRM_BUTTON_LABEL": "삭제"
          }
        },
        "EDIT_CONFIGURATION": "설정 수정"
      },
      "LAYOUT_CONTENT": {
        "HEADER": "외관",
        "DESCRIPTION": "Pick the layout that fits how your visitors read.",
        "LAYOUT": {
          "CLASSIC": {
            "TITLE": "Classic",
            "DESCRIPTION": "A welcoming home page with search and featured topics."
          },
          "SIDEBAR": {
            "TITLE": "Documentation",
            "DESCRIPTION": "Side-by-side navigation that keeps every guide a click away."
          }
        },
        "SOCIAL_LINKS": {
          "HEADER": "Social links",
          "DESCRIPTION": "Add the handle for each network and your help center builds the full link. Shown in the documentation layout footer.",
          "PLACEHOLDER": "handle",
          "ADD": "Add social link",
          "REMOVE": "제거"
        },
        "SAVE": "변경사항 저장"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "포털이 성공적으로 생성되었습니다",
          "ERROR_MESSAGE": "포털을 생성할 수 없습니다"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "포털이 성공적으로 업데이트되었습니다",
          "ERROR_MESSAGE": "포털을 업데이트할 수 없습니다"
        }
      }
    },
    "PDF_UPLOAD": {
      "TITLE": "PDF 문서 업로드",
      "DESCRIPTION": "PDF 문서를 업로드하여 AI를 사용해 자동으로 FAQ를 생성합니다",
      "DRAG_DROP_TEXT": "PDF 파일을 여기에 끌어다 놓거나 클릭하여 선택하십시오",
      "SELECT_FILE": "PDF 파일 선택",
      "ADDITIONAL_CONTEXT_LABEL": "추가 컨텍스트 (선택 사항)",
      "ADDITIONAL_CONTEXT_PLACEHOLDER": "FAQ 생성을 위한 추가 컨텍스트 또는 지침을 제공하십시오...",
      "UPLOADING": "업로드 중...",
      "UPLOAD": "업로드 및 처리",
      "CANCEL": "취소",
      "ERROR_INVALID_TYPE": "유효한 PDF 파일을 선택하십시오",
      "ERROR_FILE_TOO_LARGE": "파일 크기는 512MB 미만이어야 합니다",
      "ERROR_UPLOAD_FAILED": "PDF 업로드에 실패했습니다. 다시 시도하십시오."
    },
    "PDF_DOCUMENTS": {
      "TITLE": "PDF 문서",
      "DESCRIPTION": "업로드된 PDF 문서를 관리하고 FAQ를 생성합니다",
      "UPLOAD_PDF": "PDF 업로드",
      "UPLOAD_FIRST_PDF": "첫 번째 PDF를 업로드하십시오",
      "UPLOADED_BY": "업로드한 사람",
      "GENERATE_FAQS": "FAQ 생성",
      "GENERATING": "생성 중...",
      "CONFIRM_DELETE": "{filename}을(를) 삭제하시겠습니까?",
      "EMPTY_STATE": {
        "TITLE": "아직 PDF 문서가 없습니다",
        "DESCRIPTION": "PDF 문서를 업로드하여 AI를 사용해 자동으로 FAQ를 생성합니다"
      },
      "STATUS": {
        "UPLOADED": "준비됨",
        "PROCESSING": "처리 중",
        "PROCESSED": "완료됨",
        "FAILED": "실패"
      }
    },
    "CONTENT_GENERATION": {
      "TITLE": "콘텐츠 생성",
      "DESCRIPTION": "PDF 문서를 업로드하여 AI를 사용해 자동으로 FAQ 콘텐츠를 생성합니다",
      "UPLOAD_TITLE": "PDF 문서 업로드",
      "DRAG_DROP": "PDF 파일을 여기에 끌어다 놓거나 클릭하여 선택하십시오",
      "SELECT_FILE": "PDF 파일 선택",
      "UPLOADING": "문서 처리 중...",
      "UPLOAD_SUCCESS": "문서가 성공적으로 처리되었습니다!",
      "UPLOAD_ERROR": "문서 업로드에 실패했습니다. 다시 시도하십시오.",
      "INVALID_FILE_TYPE": "유효한 PDF 파일을 선택하십시오",
      "FILE_TOO_LARGE": "파일 크기는 512MB 미만이어야 합니다",
      "GENERATED_CONTENT": "생성된 FAQ 콘텐츠",
      "PUBLISH_SELECTED": "선택 항목 게시",
      "PUBLISHING": "게시 중...",
      "FROM_DOCUMENT": "문서에서",
      "NO_CONTENT": "생성된 콘텐츠가 없습니다. PDF 문서를 업로드하여 시작하십시오.",
      "LOADING": "생성된 콘텐츠를 불러오는 중..."
    }
  }
}
